/* unplugin-vue-components disabled */import { render } from "./tracker-contacts.vue?vue&type=template&id=4d6d680e&scoped=true"
import script from "./tracker-contacts.vue?vue&type=script&lang=js"
export * from "./tracker-contacts.vue?vue&type=script&lang=js"

import "./tracker-contacts.vue?vue&type=style&index=0&id=4d6d680e&scoped=true&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6d680e"],['__file',"src/pages/pulse/tracker/tracker-contacts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d6d680e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d6d680e', __exports__)) {
    api.reload('4d6d680e', __exports__)
  }
  
  module.hot.accept("./tracker-contacts.vue?vue&type=template&id=4d6d680e&scoped=true", () => {
    api.rerender('4d6d680e', render)
  })

}


export default __exports__